"use strict";

exports.__esModule = true;
exports.filterCustomTags = void 0;

var _safelyParseJsonData = require("../../renderer/utils/safely-parse-json-data");

var filterCustomTags = function filterCustomTags(advancedSeoData) {
  var filteredTags;

  if (typeof advancedSeoData === 'string') {
    filteredTags = (0, _safelyParseJsonData.safelyParseJsonData)(advancedSeoData);
  }

  filteredTags = (filteredTags || advancedSeoData).tags.filter(function (tag) {
    return !tag.custom;
  });
  return {
    tags: filteredTags
  };
};

exports.filterCustomTags = filterCustomTags;